module.exports = __webpack_public_path__ + "static/media/riskPriorStroke.ef9d7e78.mp3";